<template>
  <footer class="footer" :class="[this.IsChangefooter, this.IspageName]">
    <hr style="border-top: 1px solid #505f74" />

    <div class="container hk-container-padding pt-0 py-md-4 py-lg-4">
      <div class="row pt-0">
        <!-- solution start -->
        <div class="col mob-text-center pt-0 pt-md-0 pt-lg-0 col-md-4 col-12">
          <h1 class="text-black fs-14">
            {{ $t("menubar.solutions.solutions") }}
          </h1>
          <ul class="list-unstyled">
            <li>
              <router-link
                class="nav-link"
                :to="'/property-management-system'"
                >{{ $t("menubar.solutions.hk_pms") }}</router-link
              >
            </li>
            <li>
              <router-link class="nav-link" :to="'/rate-management-system'"
                >HotelKey Rate Management System</router-link
              >
            </li>
            <li>
              <router-link class="nav-link" :to="'/retailkey'">{{
                $t("menubar.solutions.hk-rk")
              }}</router-link>
            </li>
            <li>
              <router-link class="nav-link" :to="'/event-key'">{{
                $t("menubar.solutions.hk_ek")
              }}</router-link>
            </li>
            <li>
              <router-link class="nav-link" :to="'/central-reservation-system'">
                {{ $t("menubar.solutions.hk_crs") }}</router-link
              >
            </li>
            <li>
              <router-link class="nav-link" :to="'/business-intelligence'">
                {{ $t("product_menus.bi") }}</router-link
              >
            </li>
            <li>
              <router-link class="nav-link" :to="'/payment-key'">{{
                $t("menubar.solutions.hk_pk")
              }}</router-link>
            </li>
            <li>
              <router-link class="nav-link" :to="'/integrations'">{{
                $t("product_menus.integrations")
              }}</router-link>
            </li>
            <li>
              <router-link class="nav-link" :to="'/ioTkey'">{{
                $t("product_menus.iot_key")
              }}</router-link>
            </li>
            <li>
              <router-link class="nav-link" :to="'/tenant-key'">{{
                $t("menubar.solutions.hk-tk")
              }}</router-link>
            </li>
            <!-- <li>
                        <router-link class="nav-link" :to="'/guestkey'">{{ $t('menubar.solutions.hk_gk') }}</router-link>
                    </li> -->
            <!-- <li>
                        <router-link class="nav-link" :to="'/activity-key'">{{ $t('menubar.solutions.hk_ak') }}</router-link>
                    </li> -->
            <li>
              <router-link class="nav-link" :to="'/train-key'">{{
                $t("menubar.solutions.hk_trainkey")
              }}</router-link>
            </li>
          </ul>
        </div>
        <!-- solution end  -->

        <!-- About us start -->
        <div class="col mob-text-center pt-0 pt-md-0 pt-lg-0">
          <h1 class="text-black fs-14">{{ $t("nav_bar.about_us") }}</h1>
          <ul class="list-unstyled">
            <li>
              <router-link class="nav-link" :to="'/support'">{{
                $t("menubar.about_us_dropdown.support")
              }}</router-link>
            </li>
            <li>
              <router-link class="nav-link" :to="'/company'">{{
                $t("nav_bar.about_us")
              }}</router-link>
            </li>
            <li>
              <router-link class="nav-link" :to="'/our-office'">{{
                $t("menubar.about_us_dropdown.our_office")
              }}</router-link>
            </li>
            <li>
              <router-link class="nav-link" :to="'/careers'">{{
                $t("menubar.about_us_dropdown.work_with_us")
              }}</router-link>
            </li>
            <li>
              <router-link class="nav-link" :to="'/news-blogs'"
                >News/Blogs</router-link
              >
            </li>
            <li>
              <router-link class="nav-link" :to="'/contact-team'">{{
                $t("menubar.about_us_dropdown.contact_us")
              }}</router-link>
            </li>
            <li>
              <router-link class="nav-link" :to="'/testimonials'"
                >Testimonials</router-link
              >
            </li>
            <li>
              <a
                class="nav-link"
                href="https://hotelkey.keka.com/careers/"
                target="_blank"
                rel="noopener"
              >Careers</a>
            </li>
          </ul>
        </div>
        <!-- About us end -->
        <!-- industry start -->
        <div class="col mob-text-center pt-0 pt-md-0 pt-lg-0">
          <h1 class="text-black fs-14">Quick Link</h1>
          <ul class="list-unstyled">
            <li>
              <router-link class="nav-link" :to="'/overviews'">{{
                $t("menubar.overview")
              }}</router-link>
            </li>
            <li>
              <router-link class="nav-link" :to="'/Region'"
                >Regions</router-link
              >
            </li>
            <li>
              <router-link class="nav-link" :to="'/industries'">{{
                $t("menubar.industries")
              }}</router-link>
            </li>
          </ul>
        </div>
        <!-- industry end -->

        <div
          class="col-12 col-md-5 col-lg-5 order-md-0 order-lg-0 order-1 pb-3 pb-md-0 pb-lg-0"
        >
          <div class="testimonial-box-innner">
            <div
              class="d-flex hk-align-items-center ml-1 justify-content-lg-start justify-content-md-start"
            >
              <div class="mb-0">
                <router-link :to="'/'"
                  ><img
                    src="@/assets/logo/hk-logo-black.svg"
                    loading="lazy"
                    style="height: 30px"
                    alt="hk-logo-black"
                /></router-link>
              </div>
              <span class="text-black footerv-line">|</span>
              <p class="text-ssm">{{ $t("home_page.hk_slogan") }}</p>
            </div>
          </div>
          <div class="mt-2">
            <span class="fs-14 footer-pharagraph">{{
              $t("footer.footer_mini_text")
            }}</span>
          </div>
          <div>
            <span class="fs-14 footer-pharagraph">
              {{ $t("footer.footer_large_text") }}
            </span>
          </div>
          <!-- <div class="">
                    <h6 class="font-weight-bold mt-5">Subscribe to our newsletter</h6>
                    <form class="form-inline">
                        <div class="input-group mb-2 mr-sm-2">
                            <input type="email" class="form-control" placeholder="Email" />
                            <div class="input-group-append">
                                <button type="submit" class="btn btn-primary">Submit</button>
                            </div>
                        </div>
                    </form>
                </div> -->

          <!-- <hr class="d-block d-sm-block d-md-none d-lg-none d-xl-none"> -->
          <div class="col-12 col-sm-12 d-block m-text-center my-auto">
            <!-- <h5 class="mob-footer-header-color text-uppercase fs-14">connect with us </h5> -->
            <div class="d-inline-block mb-0 hk-list-inline-item mt-2">
              <span class="d-inline-block fs-14 text-uppercase m-fw-600 me-2">
                {{ $t("footer.contact_with_us") }} <span> - </span>
              </span>
              <span class="d-inline-block hk-list-inline-item me-2">
                <a
                  href="https://www.facebook.com/hotelkeyapp/"
                  aria-label="facebook"
                  class="hk-a"
                  target="_blank"
                >
                  <i class="fa-brands fa-square-facebook"></i>
                </a>
              </span>
              <span class="d-inline-block hk-list-inline-item me-2">
                <a
                  href="https://twitter.com/HotelKeyInc"
                  aria-label="twitter"
                  class="hk-a"
                  target="_blank"
                >
                  <i class="fa-brands fa-x-twitter"></i>
                </a>
              </span>
              <span class="d-inline-block hk-list-inline-item me-2">
                <a
                  href="https://www.instagram.com/hotelkeyinc/"
                  aria-label="instagram"
                  class="hk-a"
                  target="_blank"
                >
                  <i class="fa-brands fa-square-instagram"></i>
                </a>
              </span>
              <span class="d-inline-block hk-list-inline-item me-2">
                <a
                  href="https://www.linkedin.com/company/hotelkey/?viewAsMember=true"
                  aria-label="linkedin"
                  class="hk-a"
                  target="_blank"
                >
                  <i class="fa-brands fa-linkedin"></i>
                </a>
              </span>
              <!-- <span class="d-inline-block hk-list-inline-item me-2">
            <a href="https://www.youtube.com/channel/UCxgi25bCnfNAhSj5-E8H0jQ?view_as=subscriber" class="hk-a" target="_blank">
                <font-awesome-icon icon="fa-brands fa-square-youtube" class="text-black"/>
            </a>
        </span> -->
              <span class="d-inline-block hk-list-inline-item me-2">
                <a
                  href="https://wa.me/19724397067"
                  aria-label="whatsapp"
                  class="hk-a"
                  target="_blank"
                >
                  <i class="fa-brands fa-square-whatsapp"></i>
                </a>
              </span>
            </div>
          </div>
          <div class="pt-3 d-block m-text-center">
            <img
              src="@/assets/logo/hk_ssl_black.svg"
              alt="ssl"
              loading="lazy"
              class="w-50"
            />
          </div>
        </div>

        <!-- Overview start -->
        <!-- <div class="col mob-text-center pt-0 pt-md-0 pt-lg-0">
                <h1 class="text-black fs-14">Overviews</h1>
                <ul class="list-unstyled">
                </ul>
            </div> -->
        <!-- overview end -->

        <!-- region start -->
        <!-- <div class="col mob-text-center pt-0 pt-md-0 pt-lg-0">
                <h1 class="text-black fs-14">Region</h1>
                <ul class="list-unstyled">
                    <li>
                        <router-link class="nav-link" :to="'/contact-team'">{{
                $t("nav_bar.contact_us")
              }}</router-link>
                    </li>
                </ul>
            </div> -->
        <!-- region end -->
      </div>
      <!-- Img show in screen md $ lg -->
    </div>
  </footer>
</template>

<script>
// import $ from 'jquery';
// const { Toast } = bootstrap
import axios from "axios";
import FooterMini from "./FooterMini.vue";

export default {
  components: { FooterMini },
  name: "FooterBar",
  data() {
    return {
      IsChangefooter: "",
    };
  },
  computed: {
    //   IsChangefooter() {
    // return this.$i18n.locale;
    // },
    IspageName() {
      return this.$route.name;
    },
  },
  mounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
@import "@/assets/sass/config/variables.scss";
@import "@/assets/sass/main.scss";

footer {
  background: $white;
  position: relative;
  min-height: 100px;
  margin-top: 20px;
  // margin-top: -12rem;
  // padding-top: 8rem;
}
.hk-a i {
  font-size: 1.5rem; /* Increase icon size */
  transition: transform 0.3s ease, color 0.3s ease;
  color: #000; /* Default color */
}

.hk-a:hover i {
  transform: scale(1.2); /* Zoom effect on hover */
  color: #007bff; /* Bootstrap primary blue */
}

/* Optional: Brand-specific hover colors */
.hk-a[aria-label="facebook"]:hover i {
  color: #1877f2;
}
.hk-a[aria-label="twitter"]:hover i {
  color: #1da1f2;
}
.hk-a[aria-label="instagram"]:hover i {
  color: #e1306c;
}
.hk-a[aria-label="linkedin"]:hover i {
  color: #0077b5;
}
.hk-a[aria-label="whatsapp"]:hover i {
  color: #25d366;
}

.text-ssm {
  font-size: 1rem;
  color: $main-headings;
  font-weight: 700;
  margin-bottom: 0px;
}

.main-heading {
  color: $white;
  border-left: 3px solid #59a9f7;
  padding-left: 5px;
}

.word-vline {
  font-size: 16px;
  border-left: 1px solid;
  margin: 0px 10px;
}

.footer-pharagraph {
  color: #000;
  // opacity: 0.35;
}

.footerv-line {
  font-size: 14px;
  margin: 0 5px 0 10px;
}

.footer a {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.9rem;
  letter-spacing: 0.2px;
  color: #000;
}

.mob-footer-header-color {
  font-weight: 600;
}

h6 {
  font-weight: 600;
}

.text-black.fs-14 {
  font-weight: 700;
}

.footer-bg {
  background: #f9fafd;
}

.africa-bg {
  background: #f1f2e6e6;
}

.footer.IT.HomePage {
  background: #fcf9f6 !important;
}

.footer.IotKey {
  background: #f5f9f8 !important;
}

.footer.TH.HomePage {
  background: #f1f0f4 !important;
}

.footer.ES.HomePage {
  background: #faf7ef !important;
}

.footer.DE.HomePage {
  background: #fffdf9 !important;
}

.footer.FR.HomePage {
  background: #f7f8fb !important;
}

.footer.africa.HomePage {
  background: #f1f2e6e6 !important;
}

.form-control {
  margin-right: 1rem;
  border-radius: 5px;
}

.policy {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.9rem;
  letter-spacing: 0.2px;
  color: #505f74;
}

@media (max-width: 575.98px) {
  .footer {
    padding-left: 5px;
    padding-right: 5px;
  }
}
</style>
